export default __webpack_public_path__ + "static/media/loading.616150f6.gif";